import * as style from './style.module.css';

const Container = ({ isKeyboardOpened, children }) => {
  return <div id="body-container" className={`${style.container} ${isKeyboardOpened ? style.keyboardOpen : ''}`}>{children}</div>;
};

export default Container;
